var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "success" }, [
    _vm._m(0),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "success__inner" }, [
        _c("div", { staticClass: "success__bg" }),
        _c("div", { staticClass: "content" }, [
          _vm._m(1),
          _c("div", { staticClass: "content__title" }, [
            _vm._v("Вы зарегистри­ро­ва­ны на CEO Summit 2022"),
          ]),
          _c("div", { staticClass: "content__text" }, [
            _vm._v("Ждем вас на встрече в онлайн-формате 24 ноября в 15:00"),
          ]),
          _c("div", { staticClass: "content__text" }, [
            _vm._v(
              "Ссылка придет на почтовый ящик " + _vm._s(_vm.participant.email)
            ),
          ]),
          _c("div", { staticClass: "person" }, [
            _c("div", { staticClass: "person__text" }, [_vm._v("Имя")]),
            _c("div", { staticClass: "person__text" }, [
              _vm._v(_vm._s(_vm.participant.name)),
            ]),
            _c("div", { staticClass: "person__text" }, [_vm._v("Фамилия")]),
            _c("div", { staticClass: "person__text" }, [
              _vm._v(_vm._s(_vm.participant.surname)),
            ]),
            _c("div", { staticClass: "person__text" }, [_vm._v("Телефон")]),
            _c("div", { staticClass: "person__text" }, [
              _vm._v(_vm._s(_vm.participant.phone)),
            ]),
            _c("div", { staticClass: "person__text" }, [
              _vm._v("Рабочая почта"),
            ]),
            _c("div", { staticClass: "person__text" }, [
              _vm._v(_vm._s(_vm.participant.email)),
            ]),
            _c("div", { staticClass: "person__text" }, [_vm._v("Компания")]),
            _c("div", { staticClass: "person__text" }, [
              _vm._v(_vm._s(_vm.participant.site)),
            ]),
            _c("div", { staticClass: "person__text" }, [_vm._v("Адрес сайта")]),
            _c("div", { staticClass: "person__text" }, [
              _vm._v(_vm._s(_vm.participant.company)),
            ]),
            _c("div", { staticClass: "person__text" }, [
              _vm._v("Роль в компании"),
            ]),
            _c("div", { staticClass: "person__text" }, [
              _vm._v(_vm._s(_vm.participant.role)),
            ]),
            _c("div", { staticClass: "person__text" }, [
              _vm._v("Вопрос к СЕО"),
            ]),
            _c("div", { staticClass: "person__text" }, [
              _vm._v(_vm._s(_vm.question)),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "success__lamp" }, [
      _c("img", {
        attrs: {
          src: "https://mindbox.ru/journal/events/ceosummit/images/success__lamp.png",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content__done" }, [
      _c("img", {
        attrs: {
          src: "https://mindbox.ru/journal/events/ceosummit/images/done.svg",
          alt: "done",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }